import { call, put } from 'redux-saga/effects';
import { retriable } from '../retriable';
import { HIDE_SPINNER, SHOW_SPINNER } from '../../redux/modules/spinner/spinner';
import {
    FETCH_ROOM_DEPARTMENT_MAPPING_FAILURE,
    FETCH_ROOM_DEPARTMENT_MAPPING_SUCCESS,
    SAVE_ROOM_DEPARTMENT_MAPPING_FAILURE,
    SAVE_ROOM_DEPARTMENT_MAPPING_SUCCESS,
} from '../../redux/modules/roomDepartmentMapping/roomDepartmentMapping-actions';
import {
    didApiCallFailDueToUnauthorizedUser,
    didApiCallFailDueToVersionMismatch,
    getErrorMessage,
    isValidFunction,
} from '../../constants/CommonUtil';
import { MISMATCH_IN_VERSION, SESSION_TIMEOUT } from '../../redux/modules/login/login-actions';
import { ERROR_MESSAGE, SUCCESS_MESSAGE } from '../../redux/modules/message/message-actions';
import messages from '../../constants/messages';

export function* saveRoomDepartmentMappingWorker(action) {
    yield put({ type: SHOW_SPINNER, state: { canShow: true } });
    try {
        const { api } = action;
        console.log('actionFOrSave', { action });
        const apiWithParams = `${api}`;
        const response = yield call(retriable().post, apiWithParams, action.payload);
        yield put({
            type: SAVE_ROOM_DEPARTMENT_MAPPING_SUCCESS,
            data: response.data,
        });
        if (isValidFunction(action.successCallback)) {
            action.successCallback();
        }
        yield put({
            type: SUCCESS_MESSAGE,
            message: `${messages.ROOM_DEPARTMENT.CREATE.SUCCESS}`,
        });
    } catch (e) {
        if (isValidFunction(action.failureCallBack)) {
            action.failureCallBack();
        }
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            yield put({
                type: ERROR_MESSAGE,
                message: `${messages.ROOM_DEPARTMENT.CREATE.FAILED}: ${getErrorMessage(e)}`,
            });
        }
        yield put({
            type: SAVE_ROOM_DEPARTMENT_MAPPING_FAILURE,
        });
    }
    yield put({ type: HIDE_SPINNER, state: { canShow: false } });
}

export function* fetchRoomDepartmentMappingWorker(action) {
    yield put({ type: SHOW_SPINNER, state: { canShow: true } });
    try {
        const { api } = action;
        const apiWithParams = `${api}`;
        const response = yield call(retriable().get, apiWithParams);
        yield put({
            type: FETCH_ROOM_DEPARTMENT_MAPPING_SUCCESS,
            data: response.data,
        });
        console.log('datafetchedformapping', response.data, { action });
        if (isValidFunction(action.successCallback)) {
            action.successCallback(response.data);
        }
    } catch (e) {
        console.error(e);
        if (isValidFunction(action.failureCallback)) {
            action.failureCallback();
        }
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            yield put({
                type: ERROR_MESSAGE,
                message: `${messages.ROOM_DEPARTMENT.FETCH_FAILED}: ${getErrorMessage(e)}`,
            });
        }
        yield put({
            type: FETCH_ROOM_DEPARTMENT_MAPPING_FAILURE,
        });
    }
    yield put({ type: HIDE_SPINNER, state: { canShow: false } });
}
